import Introduction3Container from './introduction3'

export default Introduction3Container